if (import.meta.env.MODE === 'FIELD') {
  await import('./main-field.ts');
} else {
  await import('./main-office.ts');
}
